"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rp = require("request-promise");
const loose_object_kit_1 = require("./loose.object.kit");
const data_source_provider_remote_1 = require("./data.source.provider.remote");
const T_T = require("cryface");
var AlfreHttp;
(function (AlfreHttp) {
    let ParamType;
    (function (ParamType) {
        ParamType[ParamType["Json"] = 0] = "Json";
        ParamType[ParamType["URLEncode"] = 1] = "URLEncode";
        // Form
    })(ParamType = AlfreHttp.ParamType || (AlfreHttp.ParamType = {}));
    let MethodType;
    (function (MethodType) {
        MethodType[MethodType["Get"] = 0] = "Get";
        MethodType[MethodType["Post"] = 1] = "Post";
        MethodType[MethodType["Patch"] = 2] = "Patch";
    })(MethodType = AlfreHttp.MethodType || (AlfreHttp.MethodType = {}));
    /**
     * only Get And Post Works So far
     */
    class Provider extends data_source_provider_remote_1.DataSourceProviderRemote {
        constructor() {
            super('HttpProvider');
            this.headers = new loose_object_kit_1.LooseObject.LooseObjKit();
            this.uri = null;
            this.urlParams = [];
            this.paramType = ParamType.URLEncode;
            this.method = MethodType.Get;
            this.resolveWithFullResponse = true;
            this.responseAsJson = true;
        }
        setHeaders(headers) {
            headers.map((header) => {
                this.headers.setAttr(header.key, header.value);
            });
        }
        setHeader(key, value) {
            this.headers.setAttr(key, value);
        }
        setResponseAsJson(value) {
            this.responseAsJson = value;
        }
        setresolveWithFullResponse(value) {
            this.resolveWithFullResponse = value;
        }
        setUri(uri) {
            this.uri = uri;
        }
        setParam(key, value) {
            this.urlParams.push({
                key: key,
                value: value
            });
        }
        setPostBody(body) {
            if (T_T.simpleDetect(body)) {
                this.postBody = body;
            }
        }
        setParamType(paramType) {
            this.paramType = paramType;
        }
        setMethod(method) {
            this.method = method;
        }
        async fetch(key = 'http') {
            if (!T_T.simpleDetect(this.uri)) {
                console.log('Warning: No Uri Provided.');
                return;
            }
            switch (this.method) {
                case MethodType.Get: {
                    const options = {};
                    options.method = 'GET';
                    options.uri = this.uri;
                    options.headers = this.headers.get();
                    options.json = this.responseAsJson;
                    options.resolveWithFullResponse = this.resolveWithFullResponse;
                    if (this.urlParams.length > 0) {
                        this.uri = `${this.uri}?`;
                        for (let i = 0; i < this.urlParams.length; i++) {
                            this.uri = `${this.uri}${this.urlParams[0].key}=${this.urlParams[0].value}`;
                        }
                    }
                    try {
                        const result = await rp(options);
                        this.addData({ key: key, value: result });
                    }
                    catch (e) {
                        throw e;
                    }
                    break;
                }
                case MethodType.Post: {
                    const options = {};
                    options.method = 'POST';
                    options.uri = this.uri;
                    options.headers = this.headers.get();
                    options.json = this.responseAsJson;
                    options.resolveWithFullResponse = this.resolveWithFullResponse;
                    switch (this.paramType) {
                        case ParamType.Json: {
                            if (T_T.simpleDetect(this.postBody)) {
                                options.body = this.postBody;
                                this.setHeader('Content-Type', 'application/json');
                            }
                            break;
                        }
                        case ParamType.URLEncode: {
                            if (T_T.simpleDetect(this.postBody)) {
                                options.form = this.postBody;
                                this.setHeader('Content-Type', 'application/x-www-form-urlencoded');
                            }
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                    try {
                        const result = await rp(options);
                        this.addData({ key: key, value: result });
                    }
                    catch (e) {
                        throw e;
                    }
                    break;
                }
                case MethodType.Patch: {
                    break;
                }
                default: {
                    break;
                }
            }
        }
        async clear() {
            this.uri = '';
            this.urlParams = [];
            this.headers = new loose_object_kit_1.LooseObject.LooseObjKit();
            this.method = MethodType.Get;
            this.paramType = ParamType.URLEncode;
            this.postBody = {};
            this.responseAsJson = true;
            this.resolveWithFullResponse = true;
            this.clearData();
        }
    }
    AlfreHttp.Provider = Provider;
})(AlfreHttp = exports.AlfreHttp || (exports.AlfreHttp = {}));
//# sourceMappingURL=alfre.http.provider.js.map